'use strict';

exports.__esModule = true;
exports.SettingsDropdown = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _defaultMessages = require('../lang/default-messages');

var _defaultMessages2 = _interopRequireDefault(_defaultMessages);

var _style = require('../../src/styles/style.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var onlineGP = '';

var SettingsDropdown = function SettingsDropdown(props) {
	var isOpen = props.isOpen,
	    currentProfile = props.currentProfile,
	    logOut = props.logOut,
	    showProfileWizard = props.showProfileWizard,
	    intl = props.intl;


	return _react2.default.createElement(
		'div',
		{ className: '' + _style.settings },
		//	PATIENT SETTINGS NAV
		currentProfile.type === 'patient' && isOpen ? _react2.default.createElement(
			'div',
			{ className: _style.navSettingsDropdown + ' ' + _style.navDropdown + ' ' + _style.dropdownMenuContainer },
			_react2.default.createElement(
				'div',
				{ className: _style.inner },
				_react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: onlineGP },
							_react2.default.createElement('i', { className: 'ion-ios-email-outline' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.GET_A_REFERRAL)
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/patient/' + currentProfile.uri_id + '/edit/account' },
							_react2.default.createElement('i', { className: 'ion-ios-person-outline' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.MY_ACCOUNT)
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/patient/' + currentProfile.uri_id + '/edit/appointments' },
							_react2.default.createElement('i', { className: 'ion-ios-list-outline' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.APPOINTMENTS)
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ onClick: function onClick() {
									logOut();
								} },
							_react2.default.createElement('i', { className: 'ion-log-out' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.LOG_OUT)
							)
						)
					)
				)
			)
		) : currentProfile.type !== 'patient' && isOpen ? _react2.default.createElement(
			'div',
			{ className: _style.navSettingsDropdown + ' ' + _style.navDropdown + ' ' + _style.dropdownMenuContainer },
			_react2.default.createElement(
				'div',
				{ className: _style.inner },
				_react2.default.createElement(
					'ul',
					null,
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ href: '/specialist/' + currentProfile.uri_id + '/edit/account' },
							_react2.default.createElement('i', { className: 'ion-ios-person-outline' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.MY_ACCOUNT)
							)
						)
					),
					_react2.default.createElement(
						'li',
						null,
						_react2.default.createElement(
							'a',
							{ onClick: logOut },
							_react2.default.createElement('i', { className: 'ion-log-out' }),
							_react2.default.createElement(
								'span',
								null,
								intl.formatMessage(_defaultMessages2.default.LOG_OUT)
							)
						)
					)
				)
			)
		) : null
	);
};
SettingsDropdown.propTypes = {
	currentProfile: require('react').PropTypes.any.isRequired,
	isOpen: require('react').PropTypes.bool.isRequired,
	logOut: require('react').PropTypes.func.isRequired,
	showProfileWizard: require('react').PropTypes.func.isRequired
};
var hoc = (0, _reactIntl.injectIntl)(SettingsDropdown);

exports.SettingsDropdown = hoc;


// WEBPACK FOOTER //
// ./components/top-nav/lib/components/settings-dropdown.js